import { v4 as uuid } from 'uuid'

interface PageViewParams {
  pageUrl: string
  userId: string | null
}

export const gaPageView = (params: PageViewParams) => {
  window.dataLayer?.push({
    event: 'page_view',

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}

interface PurchaseParams {
  pageUrl: string
  id: string
  title: string
  price: number
  userId: string | null
}

export const gaPurchase = (params: PurchaseParams) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const transactionId = `purchase-${uuid()}`

  window.dataLayer?.push({ ecommerce: null })
  window.dataLayer?.push({
    event: 'purchase',
    ecommerce: {
      currency: 'KRW',
      transaction_id: transactionId,
      value: params.price,
      items: [
        {
          item_id: params.id,
          item_name: params.title,
          price: params.price,
        },
      ],
    },

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}

interface AddToCartParams {
  pageUrl: string
  id: string
  title: string
  price: number
  categoryName?: string
  userId: string | null
}

export const gaAddToCart = (params: AddToCartParams) => {
  window.dataLayer?.push({ ecommerce: null })
  window.dataLayer?.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'KRW',
      value: params.price,
      items: [
        {
          item_id: params.id,
          item_name: params.title,
          price: params.price,
          item_category: params.categoryName,
        },
      ],
    },

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}

interface RemoveToCartParams {
  pageUrl: string
  items: {
    id: string
    title: string
    price: number
    categoryName?: string
  }[]
  userId: string | null
}

export const gaRemoveToCart = (params: RemoveToCartParams) => {
  window.dataLayer?.push({ ecommerce: null })
  window.dataLayer?.push({
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'KRW',
      value: params.items
        .filter((item) => item.price)
        .reduce((acc, cur) => acc + cur.price, 0),
      items: params.items.map((item) => ({
        item_id: item.id,
        item_name: item.title,
        price: item.price,
        item_category: item.categoryName,
      })),
    },

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}

interface ViewItemParams {
  pageUrl: string
  item: {
    id: string
    title: string
    price: number
    categoryName?: string
  }
  userId: string | null
}

export const gaViewItem = (params: ViewItemParams) => {
  window.dataLayer?.push({ ecommerce: null })
  window.dataLayer?.push({
    event: 'view_item',
    ecommerce: {
      currency: 'KRW',
      value: params.item.price,
      items: [
        {
          item_id: params.item.id,
          item_name: params.item.title,
          price: params.item.price,
          item_category: params.item.categoryName,
        },
      ],
    },

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}

interface LogInParams {
  method: 'kakao' | 'google'
  pageUrl: string
  isSignUp: boolean
}

export const gaLogIn = (params: LogInParams) => {
  window.dataLayer?.push({
    event: params.isSignUp ? 'sign_up' : 'login',
    method: params.method,

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
  })
}

interface SearchParams {
  pageUrl: string
  searchTerm: string
  searchResultsCount: number
  searchType: 'word' | 'link'
  userId: string | null
}

export const gaSearch = (params: SearchParams) => {
  window.dataLayer?.push({
    event: 'search',
    search_term: params.searchTerm,
    search_results_count: params.searchResultsCount,
    search_type: params.searchType,

    page_title: document.querySelector('title')?.innerText || '',
    page_url: params.pageUrl,
    user_id: params.userId,
    login_status: !!params.userId,
  })
}
